import { customerApi } from './customerApi';

const LS_OTP = 'flare_store_otp';
const LS_TEST_MAILBOX = 'flare_store_test_mailbox';
const OTP_TTL_MS = 15 * 60 * 1000;
const RESEND_COOLDOWN_S = 60;

const LOGO_URL = 'https://flare.pk/wp-content/uploads/2024/10/Flare-Pakistan-Logo.png';
const STORE_URL = 'https://digital.flare.pk';
const YEAR = new Date().getFullYear();
const BRAND_TAGLINE = 'Pakistan Tech and Business News';

function buildShell({ headerBg = 'linear-gradient(135deg,#c4151c 0%,#9f1016 100%)', headerTitle, headerSubtitle = '', bodyHtml, footerHtml = '' }) {
  return `
<div style="font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif; max-width: 580px; margin: 0 auto; background: #f9fafb; padding: 18px 10px;">
  <div style="background: #fff; border-radius: 18px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.06);">

    <div style="padding: 22px 28px; background: ${headerBg}; color:#fff;">
      <table cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse:collapse;">
        <tr>
          <td width="120" valign="middle" style="vertical-align:middle;">
            <div style="width: 104px; height: 68px; background:#ffffff; border-radius: 14px; box-shadow: 0 3px 10px rgba(0,0,0,0.18); display:block; text-align:center; line-height: 68px;">
              <img src="${LOGO_URL}" alt="Flare Magazine" width="92" height="33" style="display:inline-block; vertical-align:middle; border:0; outline:none; line-height:1; width:92px; height:auto; text-decoration:none;" />
            </div>
          </td>
          <td valign="middle" style="vertical-align:middle; padding-left: 16px;">
            <div style="margin:0; font-size: 20px; font-weight: 800; letter-spacing: 0.3px; line-height: 1.15; white-space: nowrap;">${headerTitle}</div>
            ${headerSubtitle ? `<div style="margin: 5px 0 0; font-size: 13px; opacity: 0.95; letter-spacing: 0.15px; line-height: 1.4;">${headerSubtitle}</div>` : ''}
          </td>
        </tr>
      </table>
    </div>

    <div style="padding: 28px; background:#fff;">
      ${bodyHtml}
    </div>

    ${footerHtml || defaultFooter()}

  </div>
</div>`;
}

function defaultFooter() {
  return `
    <div style="padding: 24px 28px; background: linear-gradient(180deg,#fafafa 0%,#f4f4f5 100%); border-top: 1px solid #e5e7eb;">
      <table cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse:collapse;">
        <tr>
          <td valign="top" style="vertical-align:top; width: 60%;">
            <div style="font-size: 12px; color:#52525b; line-height: 1.75; font-weight: 500;">
              &copy; ${YEAR} Digital Flare Network<br/>
              2nd Floor, Gulberg III &middot; Lahore 54000 &middot; Pakistan<br/>
              UAN: +92-42-111-000-000 &middot; support@flare.pk
            </div>
          </td>
          <td valign="top" align="right" style="vertical-align:top; text-align: right; width: 40%;">
            <table cellpadding="0" cellspacing="0" border="0" align="right" style="border-collapse:collapse;">
              <tr>
                <td style="padding: 0 4px;">
                  <a href="https://wa.me/9242111000000" target="_blank" style="display:inline-block; width:32px; height:32px; line-height:32px; text-align:center; background:#25D366; border-radius:50%; color:#fff !important; text-decoration:none; font-size:14px; font-weight:800;"><span style="font-family:Arial,sans-serif;">W</span></a>
                </td>
                <td style="padding: 0 4px;">
                  <a href="https://facebook.com/flaremagonline" target="_blank" style="display:inline-block; width:32px; height:32px; line-height:32px; text-align:center; background:#1877F2; border-radius:50%; color:#fff !important; text-decoration:none; font-size:14px; font-weight:800;"><span style="font-family:Arial,sans-serif;">f</span></a>
                </td>
                <td style="padding: 0 4px;">
                  <a href="https://instagram.com/flaremagonline" target="_blank" style="display:inline-block; width:32px; height:32px; line-height:32px; text-align:center; background: linear-gradient(45deg,#f09433,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888); border-radius:50%; color:#fff !important; text-decoration:none; font-size:12px; font-weight:800;"><span style="font-family:Arial,sans-serif;">IG</span></a>
                </td>
                <td style="padding: 0 4px;">
                  <a href="https://youtube.com/@flaremagonline" target="_blank" style="display:inline-block; width:32px; height:32px; line-height:32px; text-align:center; background:#FF0000; border-radius:50%; color:#fff !important; text-decoration:none; font-size:11px; font-weight:800;"><span style="font-family:Arial,sans-serif;">YT</span></a>
                </td>
              </tr>
            </table>
            <div style="margin-top: 10px; font-size: 11px; color:#9ca3af;">
              <a href="${STORE_URL}/privacy-policy" style="color:#6b7280 !important; text-decoration:none;">Privacy</a>
              &nbsp;&middot;&nbsp;
              <a href="${STORE_URL}/terms-of-service" style="color:#6b7280 !important; text-decoration:none;">Terms</a>
            </div>
          </td>
        </tr>
      </table>
    </div>`;
}

function securityBadge() {
  return `<div style="margin-top: 18px; padding: 11px 14px; background: #ecfdf5; border: 1px solid #a7f3d0; border-radius: 10px; text-align: center;">
    <div style="font-size: 11.5px; color:#065f46; font-weight: 700; line-height: 1.5;">
      &#128274; Secured by AWS SES &middot; 256-bit TLS Encryption &middot; Flare never shares your email
    </div>
  </div>`;
}

function otpCard({ code, label = 'Email Verification Code', sub = 'Expires in 15 minutes', accent = '#c4151c' }) {
  return `<div style="background: linear-gradient(180deg,#fff5f5 0%,#fef2f2 100%); border: 1px solid #fecaca; border-radius: 14px; padding: 24px 22px; text-align:center; margin-bottom: 20px;">
    <div style="font-size: 11.5px; color:#991b1b; letter-spacing: 2px; font-weight: 700; margin-bottom: 12px; text-transform: uppercase;">${label}</div>
    <div style="font-size: 40px; font-weight: 900; letter-spacing: 10px; color:${accent}; font-family: 'Courier New', Courier, monospace; line-height: 1;">${code}</div>
    ${sub ? `<div style="margin-top: 10px; font-size: 12px; color:#b91c1c; font-weight: 600;">${sub}</div>` : ''}
  </div>`;
}

function ctaButton({ href, label, bg = 'linear-gradient(135deg,#c4151c 0%,#9f1016 100%)', shadow = 'rgba(196,21,28,0.28)' }) {
  return `<a href="${href}" style="display:inline-block; width:100%; box-sizing:border-box; text-align:center; background: ${bg}; color:#fff !important; text-decoration:none; padding: 13px 22px; font-weight: 800; font-size: 14.5px; border-radius: 12px; box-shadow: 0 4px 14px ${shadow}; letter-spacing: 0.3px;">${label}</a>`;
}

function greeting(name) {
  return `<p style="margin: 0 0 12px; font-size: 16px; color:#111827; font-weight: 600;">Hi ${name || 'there'},</p>`;
}

const TEMPLATES = {
  VERIFY_EMAIL: ({ code, name = 'there', minutes = 15 }) => ({
    subject: `Flare Magazine — Your Email Verification Code is ${code}`,
    html: buildShell({
      headerTitle: 'Flare Magazine',
      headerSubtitle: BRAND_TAGLINE,
      bodyHtml: `
        ${greeting(name)}
        <p style="margin: 0 0 22px; color:#374151; line-height: 1.6; font-size: 14.5px;">Thank you for registering with Flare Magazine! Please enter the verification code below to activate your account. This code is valid for <b>${minutes} minutes</b>.</p>
        ${otpCard({ code, sub: `Expires in ${minutes} minutes` })}
        ${ctaButton({ href: `${STORE_URL}/verify?otp=${code}`, label: 'Verify My Email &rarr;' })}
        ${securityBadge()}
        <p style="margin: 22px 0 4px; font-size: 12.5px; color:#6b7280; line-height: 1.6;">If you didn&#39;t request this code, safely ignore this email. Your account remains protected.</p>
        <p style="margin: 0; font-size: 12.5px; color:#6b7280; line-height: 1.6;">This is an automated message from Flare Magazine. Please do not reply directly to this email.</p>`
    })
  }),

  FORGOT_PASSWORD: ({ code, name = 'there', minutes = 15 }) => ({
    subject: `Flare Magazine — Password Reset Code is ${code}`,
    html: buildShell({
      headerTitle: 'Password Reset',
      headerSubtitle: 'Flare Magazine Customer Account',
      bodyHtml: `
        ${greeting(name)}
        <p style="margin: 0 0 22px; color:#374151; line-height: 1.6; font-size: 14.5px;">We received a password reset request for your Flare account. Use this one-time code to set a new password (valid for <b>${minutes} minutes</b>).</p>
        ${otpCard({ code, label: 'One-Time Password Reset Code', sub: `Expires in ${minutes} minutes` })}
        ${ctaButton({ href: `${STORE_URL}/reset-password?otp=${code}`, label: 'Set A New Password &rarr;' })}
        ${securityBadge()}
        <p style="margin: 22px 0 4px; font-size: 12.5px; color:#6b7280; line-height: 1.6;"><b>Security tip:</b> Never share this code with anyone. Flare Support will NEVER ask you for this code over call/WhatsApp.</p>
        <p style="margin: 0; font-size: 12.5px; color:#6b7280; line-height: 1.6;">If you didn&#39;t request this reset, change your password immediately and contact support.</p>`
    })
  }),

  WELCOME: ({ name, email, userId, planName = '', price = '' }) => ({
    subject: `Welcome to Flare Magazine, ${name}! \u{1F389} Your account is now active`,
    html: buildShell({
      headerTitle: `Welcome aboard, ${name}! \u{1F44B}`,
      headerSubtitle: 'Your Flare Magazine customer account is now fully active.',
      bodyHtml: `
        <div style="display:grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 20px;">
          <div style="background:#f9fafb; border-radius: 10px; padding: 12px 14px;">
            <div style="font-size: 11px; color:#6b7280; letter-spacing: 0.5px; font-weight: 600;">CUSTOMER ID</div>
            <div style="font-size: 15px; color:#111827; font-weight: 700; margin-top: 4px;">${userId}</div>
          </div>
          <div style="background:#f9fafb; border-radius: 10px; padding: 12px 14px;">
            <div style="font-size: 11px; color:#6b7280; letter-spacing: 0.5px; font-weight: 600;">EMAIL</div>
            <div style="font-size: 15px; color:#111827; font-weight: 700; margin-top: 4px;">${email}</div>
          </div>
        </div>
        ${planName ? `
        <div style="background: linear-gradient(135deg, #fff7ed 0%, #fef3c7 100%); border: 1px solid #fcd34d; border-radius: 12px; padding: 16px; margin-bottom: 18px;">
          <div style="font-size: 11px; color:#92400e; letter-spacing: 1px; font-weight: 700; margin-bottom: 6px;">\u2B50 YOUR ACTIVE SUBSCRIPTION</div>
          <div style="font-size: 17px; font-weight: 800; color:#92400e; margin-bottom: 2px;">${planName}</div>
          <div style="font-size: 14px; color:#78350f; font-weight: 600;">Total: ${price}</div>
        </div>` : ''}
        <p style="margin: 0 0 10px; color:#374151; line-height: 1.5;">What&#39;s next?</p>
        <ol style="margin:0 0 20px; padding-left: 18px; color:#374151; line-height: 1.8;">
          <li>Sign in at <b>digital.flare.pk/login</b> to access your customer dashboard.</li>
          <li>Track upcoming deliveries, download invoices, and manage your profile.</li>
          <li>Save 33% on a Yearly plan, or 40% on a 2-year plan &mdash; upgrade anytime from <b>/plans</b>.</li>
        </ol>
        ${ctaButton({ href: `${STORE_URL}/login`, label: 'Go to My Account &rarr;' })}
        ${securityBadge()}`
    })
  }),

  PASSWORD_CHANGED: ({ name, ip = 'Unknown', time = new Date().toLocaleString() }) => ({
    subject: `\u{1F510} Flare Magazine — Your password was changed successfully`,
    html: buildShell({
      headerBg: 'linear-gradient(135deg,#065f46 0%,#047857 100%)',
      headerTitle: 'Password Changed \u2705',
      headerSubtitle: 'Flare Magazine Account Security Notice',
      bodyHtml: `
        <div style="background:#ecfdf5; border:1px solid #a7f3d0; border-radius: 14px; padding: 18px; margin-bottom: 18px;">
          <div style="font-size: 28px; margin-bottom: 4px;">&#9989;</div>
          <h2 style="margin:0 0 6px; color:#065f46; font-size: 19px;">Password changed successfully</h2>
          <p style="margin:0; color:#047857; font-size: 14px;">Hi ${name}, your Flare account password was updated.</p>
        </div>
        <div style="background:#f9fafb; border-radius: 10px; padding: 14px 16px; border:1px solid #e5e7eb; margin-bottom: 16px;">
          <div style="font-size: 11.5px; color:#6b7280; font-weight:600;">TIMESTAMP</div>
          <div style="font-size: 14px; color:#111827; font-weight: 700;">${time}</div>
          <div style="font-size: 11.5px; color:#6b7280; font-weight:600; margin-top: 10px;">IP ADDRESS</div>
          <div style="font-size: 14px; color:#111827; font-weight: 700;">${ip}</div>
        </div>
        ${securityBadge()}
        <p style="margin: 16px 0 0; font-size: 12.5px; color:#991b1b; font-weight:600; line-height: 1.6;">&#9888;&#65039; If you did NOT make this change, contact support IMMEDIATELY at support@flare.pk or call +92-42-111-000-000 to secure your account.</p>`
    })
  }),

  ORDER_CONFIRM: ({ name, orderNo, planName, amount, invoiceNo = '' }) => ({
    subject: `\u2705 Order #${orderNo} confirmed — Thank you, ${name}!`,
    html: buildShell({
      headerTitle: `Order Confirmed! \u{1F381}`,
      headerSubtitle: `Order #${orderNo} · Paid successfully`,
      bodyHtml: `
        ${greeting(name)}
        <div style="background:#f9fafb; border-radius: 12px; padding: 18px; margin-bottom: 16px;">
          <div style="display:grid; grid-template-columns: 1fr auto; gap: 10px 20px; align-items: center;">
            <div style="font-size: 15px; color:#374151;">${planName}</div>
            <div style="font-size: 16px; color:#111827; font-weight: 800;">${amount}</div>
            <div style="font-size: 13px; color:#6b7280; grid-column: 1 / -1;">Qty: 1 subscription · Digital + Printed delivery</div>
          </div>
          <hr style="border:none; border-top:1px dashed #d1d5db; margin: 14px 0;" />
          <div style="display:grid; grid-template-columns: 1fr auto; gap: 4px;">
            <div style="color:#374151;">Subtotal</div><div style="font-weight: 700;">${amount}</div>
            <div style="color:#374151;">Taxes (GST 0% exempt - print media)</div><div style="font-weight: 700;">Rs 0</div>
            <div style="color:#111827; font-weight: 800; font-size: 17px;">TOTAL PAID</div><div style="color:#c4151c; font-weight: 800; font-size: 17px;">${amount}</div>
          </div>
        </div>
        ${invoiceNo ? `<p style="margin: 0 0 10px; color:#374151; line-height: 1.6;">&#128196; Invoice #<b>${invoiceNo}</b> has been generated and is available in your account dashboard.</p>` : ''}
        <p style="margin: 0 0 18px; color:#374151; line-height: 1.6;">&#128230; Your first magazine issue will be dispatched within 5 business days via TCS Courier. You&#39;ll receive a tracking alert as soon as it ships!</p>
        ${ctaButton({ href: `${STORE_URL}/account/orders`, label: 'View Order Details &rarr;' })}
        ${securityBadge()}`
    })
  }),

  INVOICE_READY: ({ name, invoiceNo, amount, dueDate = 'Paid in advance' }) => ({
    subject: `\u{1F9FE} Invoice #${invoiceNo} is ready — Payment received, ${name}`,
    html: buildShell({
      headerBg: 'linear-gradient(135deg,#1f2937 0%,#111827 100%)',
      headerTitle: `Invoice ${invoiceNo}`,
      headerSubtitle: 'Official Flare Magazine Tax Invoice',
      bodyHtml: `
        <div style="display:flex; justify-content:space-between; align-items:flex-start; margin-bottom: 20px;">
          <div>
            <h2 style="margin: 0 0 6px; color:#111827; font-size: 22px;">Invoice #${invoiceNo}</h2>
            <div style="display:inline-block; background:#dcfce7; color:#166534; font-weight: 700; padding: 4px 12px; border-radius: 999px; font-size: 12px;">&#10003; PAID</div>
          </div>
          <div style="font-weight: 800; color:#c4151c; font-size: 26px; white-space: nowrap; margin-left: 12px;">${amount}</div>
        </div>
        <div style="display:grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 20px;">
          <div style="background:#f9fafb; padding: 12px; border-radius: 8px;">
            <div style="font-size: 11px; color:#6b7280; font-weight:600;">BILLED TO</div>
            <div style="font-size: 14px; color:#111827; font-weight: 700; margin-top: 4px;">${name}</div>
          </div>
          <div style="background:#f9fafb; padding: 12px; border-radius: 8px;">
            <div style="font-size: 11px; color:#6b7280; font-weight:600;">DUE DATE</div>
            <div style="font-size: 14px; color:#111827; font-weight: 700; margin-top: 4px;">${dueDate}</div>
          </div>
        </div>
        <div style="background:#fffbeb; border:1px dashed #fcd34d; border-radius: 10px; padding: 12px; text-align:center; margin-bottom: 20px;">
          <p style="margin: 0; font-size: 13px; color:#92400e; font-weight: 600; line-height: 1.6;">&#128196; Full PDF invoice is available to download from your customer dashboard &rarr; Invoices tab.</p>
        </div>
        ${ctaButton({ href: `${STORE_URL}/account/invoices`, label: 'Download Invoice PDF &rarr;' })}
        ${securityBadge()}`
    })
  }),

  SUBSCRIPTION_ACTIVATED: ({ name, planName, duration, start, end, issues, address }) => ({
    subject: `\u26A1 Your ${planName} subscription is now ACTIVE`,
    html: buildShell({
      headerBg: 'linear-gradient(135deg,#064e3b 0%,#065f46 100%)',
      headerTitle: `Subscription Activated! \u{1F680}`,
      headerSubtitle: `Get ready for ${issues} issues delivered to your doorstep.`,
      bodyHtml: `
        ${greeting(name)}
        <div style="display:grid; grid-template-columns: 1fr 1fr; gap: 10px 20px; margin-bottom: 18px;">
          <div><div style="font-size: 11px; color:#6b7280; font-weight:600;">PLAN</div><div style="font-weight:800; color:#111827;">${planName}</div></div>
          <div><div style="font-size: 11px; color:#6b7280; font-weight:600;">DURATION</div><div style="font-weight:700; color:#111827;">${duration}</div></div>
          <div><div style="font-size: 11px; color:#6b7280; font-weight:600;">STARTS</div><div style="font-weight:700; color:#111827;">${start}</div></div>
          <div><div style="font-size: 11px; color:#6b7280; font-weight:600;">ENDS</div><div style="font-weight:700; color:#111827;">${end}</div></div>
          <div style="grid-column:1 / -1;"><div style="font-size: 11px; color:#6b7280; font-weight:600;">DELIVERY ADDRESS</div><div style="font-weight:700; color:#111827;">${address || '&#8212;'}</div></div>
        </div>
        ${ctaButton({ href: `${STORE_URL}/account/subscriptions`, label: 'Manage My Subscription &rarr;', bg: 'linear-gradient(135deg,#065f46,#047857 100%)', shadow: 'rgba(6,95,70,0.25)' })}
        ${securityBadge()}
        <p style="margin: 16px 0 0; color:#374151; font-size: 13px; line-height: 1.6;">&#128222; Questions? Call Reader Care: +92-42-111-000-000 · 9am-6pm Mon-Sat</p>`
    })
  }),

  ISSUE_SHIPPED: ({ name, issueName, trackingNo, dispatchDate = 'Today' }) => ({
    subject: `\u{1F4E6} ${issueName} is on its way! TCS tracking #${trackingNo}`,
    html: buildShell({
      headerBg: 'linear-gradient(135deg,#1e3a8a 0%,#1e40af 100%)',
      headerTitle: `${issueName} has shipped! \u{1F69A}`,
      headerSubtitle: `Dispatched ${dispatchDate} via TCS Courier`,
      bodyHtml: `
        ${greeting(name)}
        <div style="background:#eff6ff; border:1px solid #bfdbfe; border-radius: 14px; padding: 20px; text-align:center; margin-bottom: 16px;">
          <div style="font-size: 12px; color:#1e40af; font-weight: 600; letter-spacing: 1.5px; margin-bottom: 8px;">TCS TRACKING NUMBER</div>
          <div style="font-size: 28px; font-weight: 800; color:#1e3a8a; font-family: 'Courier New', monospace; letter-spacing: 3px;">${trackingNo}</div>
        </div>
        ${ctaButton({ href: `https://www.tcsexpress.com/track/${trackingNo}`, label: 'Track Your Package on TCS &rarr;', bg: 'linear-gradient(135deg,#1e40af 0%,#1d4ed8 100%)', shadow: 'rgba(30,64,175,0.28)' })}
        ${securityBadge()}
        <p style="margin: 14px 0 0; color:#4b5563; font-size: 13px; text-align:center; line-height: 1.6;">&#128197; Estimated delivery: 2&ndash;3 business days inside Pakistan. You may receive an SMS from TCS with the exact slot.</p>`
    })
  }),

  NEWSLETTER_WELCOME: ({ name = 'Subscriber', email }) => ({
    subject: `\u{1F4EC} Welcome to the Flare Newsletter, ${name}!`,
    html: buildShell({
      headerBg: 'linear-gradient(135deg,#9a3412 0%,#c2410c 100%)',
      headerTitle: `You're in! Welcome to Flare Flash \u{1F4F0}`,
      headerSubtitle: `${email}`,
      bodyHtml: `
        <div style="font-size: 36px; text-align: center; margin-bottom: 10px;">&#9993;&#65039;</div>
        <p style="margin: 0 0 16px; text-align:center; color:#7c2d12; font-size: 15px; font-weight: 600;">Thank you for subscribing to the Flare Flash Newsletter!</p>
        <div style="background:#fff; border-radius: 10px; padding: 16px; margin-bottom: 18px; border:1px solid #fed7aa;">
          <p style="margin: 0 0 8px; color:#374151;"><b>What you&#39;ll receive every week:</b></p>
          <ul style="margin: 0; padding-left: 18px; color:#374151; line-height: 1.85;">
            <li>Exclusive cover previews of upcoming issues</li>
            <li>Investigative deep-dive stories before print release</li>
            <li>Subscriber-only flash sales &amp; discount codes (up to 50% OFF)</li>
            <li>Event invitations for Flare Magazine &amp; Mix FM Network</li>
          </ul>
        </div>
        ${ctaButton({ href: `${STORE_URL}/plans`, label: 'Browse Subscription Plans', bg: 'linear-gradient(135deg,#c2410c 0%,#ea580c 100%)', shadow: 'rgba(194,65,12,0.25)' })}
        ${securityBadge()}
        <p style="margin: 14px 0 0; font-size: 11.5px; color:#9a3412; text-align:center; line-height: 1.6;">
          Don&#39;t want these? <a href="${STORE_URL}/unsubscribe?e=${encodeURIComponent(email)}" style="color:#9a3412; text-decoration: underline;">Unsubscribe from newsletter</a>
        </p>`
    })
  }),

  CONTACT_RECEIVED: ({ name, refNo, subject }) => ({
    subject: `\u2705 Contact Request #${refNo} received — We'll get back to you soon!`,
    html: buildShell({
      headerBg: 'linear-gradient(135deg,#3730a3 0%,#4338ca 100%)',
      headerTitle: `Message received! \u{1F4E8}`,
      headerSubtitle: `Reference #${refNo} · Quote it in any follow-up.`,
      bodyHtml: `
        ${greeting(name)}
        <div style="background:#fff; border-radius: 10px; padding: 14px; margin-bottom: 18px; border:1px solid #e0e7ff;">
          <div style="font-size: 11px; color:#6b7280; font-weight:600;">SUBJECT</div>
          <div style="font-size: 15px; color:#111827; font-weight: 700; margin-top: 4px;">${subject || '&#8212;'}</div>
        </div>
        ${ctaButton({ href: `${STORE_URL}/contact`, label: 'View Contact Page', bg: 'linear-gradient(135deg,#4338ca 0%,#4f46e5 100%)', shadow: 'rgba(67,56,202,0.28)' })}
        ${securityBadge()}
        <p style="margin: 16px 0 0; color:#4338ca; font-size: 13px; text-align:center;">&#9201;&#65039; Response time: Within 24 hours (Mon &ndash; Sat, 9am &ndash; 6pm PKT)</p>`
    })
  }),

  RENEWAL_REMINDER: ({ name, planName, daysLeft = 3, endDate, renewalPrice, orderLink = `${STORE_URL}/plans` }) => ({
    subject: `\u23F0 Your Flare ${planName} expires in ${daysLeft} days — Renew now!`,
    html: buildShell({
      headerBg: 'linear-gradient(135deg,#b45309 0%,#92400e 100%)',
      headerTitle: `Renewal Reminder: ${daysLeft} days left \u23F3`,
      headerSubtitle: `Don't miss a single issue of Flare Magazine`,
      bodyHtml: `
        ${greeting(name)}
        <div style="background:#fffbeb; border:1px solid #fde68a; border-radius: 12px; padding: 16px; margin-bottom: 18px;">
          <div style="display:grid; grid-template-columns:1fr auto; gap: 4px 20px;">
            <div style="color:#78350f;">Plan</div><div style="font-weight: 800; color:#92400e;">${planName}</div>
            <div style="color:#78350f;">Expires on</div><div style="font-weight: 700; color:#92400e;">${endDate}</div>
            <div style="color:#78350f;">Renewal Price</div><div style="font-weight: 800; color:#c4151c; font-size: 18px;">${renewalPrice}</div>
          </div>
        </div>
        ${ctaButton({ href: orderLink, label: '&#128260; Renew My Subscription Now', bg: 'linear-gradient(135deg,#b45309 0%,#d97706 100%)', shadow: 'rgba(180,83,9,0.28)' })}
        ${securityBadge()}
        <p style="margin: 14px 0 0; font-size: 12px; color:#6b7280; text-align:center; line-height: 1.6;">Renewing before expiry ensures uninterrupted delivery. Your address &amp; preferences are saved from last year.</p>`
    })
  }),

  NEW_ISSUE_ALERT: ({ name, issueName = 'Latest Issue', issueUrl = `${STORE_URL}/magazines` }) => ({
    subject: `\u{1F525} NEW ISSUE: ${issueName} is OUT NOW — Read it first!`,
    html: buildShell({
      headerBg: 'linear-gradient(135deg,#7c2d12 0%,#9a3412 100%)',
      headerTitle: `NEW ISSUE DROPPED: ${issueName} \u{1F525}`,
      headerSubtitle: 'Flare subscribers read it first — always.',
      bodyHtml: `
        ${greeting(name)}
        <p style="margin: 0 0 18px; color:#374151; line-height: 1.65; font-size: 14.5px;">Grab your hot-off-the-press copy of <b>${issueName}</b> &mdash; packed with exclusive investigations, celebrity interviews, tech reviews, lifestyle guides, and our signature political satire.</p>
        ${ctaButton({ href: issueUrl, label: '&#128214; Read Issue Now / Order Printed Copy &rarr;', bg: 'linear-gradient(135deg,#9a3412 0%,#c2410c 100%)', shadow: 'rgba(154,52,18,0.28)' })}
        ${securityBadge()}`
    })
  }),

  ACCOUNT_BANNED: ({ name, email, reason = 'Security review' }) => ({
    subject: `\u26A0\uFE0F Your Flare account (${email}) has been restricted`,
    html: buildShell({
      headerBg: 'linear-gradient(135deg,#991b1b 0%,#7f1d1d 100%)',
      headerTitle: `Account Access Restricted \u{1F6AB}`,
      headerSubtitle: `Account: ${email}`,
      bodyHtml: `
        <div style="font-size: 38px; text-align:center; margin-bottom: 8px;">&#128683;</div>
        <p style="margin: 0 0 16px; color:#7f1d1d; font-size: 14.5px; line-height: 1.65;">Hi ${name}, we&#39;re writing to inform you that access to your Flare Magazine account (${email}) has been temporarily restricted.</p>
        <div style="background:#fff; border: 1px solid #fee2e2; border-radius: 10px; padding: 14px; margin-bottom: 14px;">
          <div style="font-size: 11px; color:#991b1b; font-weight: 600; letter-spacing: 0.5px;">REASON</div>
          <div style="font-size: 14px; color:#7f1d1d; font-weight: 700; margin-top: 4px;">${reason}</div>
        </div>
        <div style="background:#fff7ed; border:1px solid #fed7aa; border-radius: 10px; padding: 14px; margin-bottom: 16px;">
          <div style="font-size: 12px; color:#9a3412; font-weight:700; margin-bottom: 4px;">How to appeal?</div>
          <p style="margin:0; color:#7c2d12; font-size: 13px; line-height: 1.6;">&#128231; Email <b>support@flare.pk</b> with your Customer ID and details OR call Reader Ombudsperson at <b>+92-42-111-000-000</b> (9am&ndash;6pm Mon&ndash;Sat PKT) for a manual review within 72 hours.</p>
        </div>
        ${securityBadge()}`
    })
  })
};

function readLS(key, fallback) {
  try { return JSON.parse(localStorage.getItem(key) || 'null') ?? fallback; }
  catch { return fallback; }
}
function writeLS(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
}

export function generateOTP(length = 6) {
  let code = '';
  for (let i = 0; i < length; i++) code += Math.floor(Math.random() * 10).toString();
  return code;
}

export function getMailbox() {
  return readLS(LS_TEST_MAILBOX, []);
}
export function clearMailbox() { writeLS(LS_TEST_MAILBOX, []); }

export async function sendEmail({ to, template, data = {}, from = 'digital@flare.pk', fromName = 'Flare Magazine' }) {
  const tpl = typeof template === 'string' ? TEMPLATES[template] : template;
  if (!tpl) throw new Error(`Invalid email template: ${template}`);
  const body = typeof tpl === 'function' ? tpl(data) : tpl;
  return {
    id: 'MAIL-LOCAL',
    to,
    from,
    fromName,
    subject: body.subject,
    html: body.html,
    sentAt: new Date().toISOString(),
    delivered: false,
  };
}

export function storeOTP({ email, type = 'VERIFY', code }) {
  const all = readLS(LS_OTP, {});
  all[`${email}__${type}`] = { code, type, email, createdAt: Date.now(), expiresAt: Date.now() + OTP_TTL_MS };
  writeLS(LS_OTP, all);
}

export function clearOTP({ email, type = 'VERIFY' }) {
  const all = readLS(LS_OTP, {});
  delete all[`${email}__${type}`];
  writeLS(LS_OTP, all);
}

export function verifyOTP({ email, type = 'VERIFY', code, consume = true }) {
  const all = readLS(LS_OTP, {});
  const entry = all[`${email}__${type}`];
  if (!entry) return { ok: false, reason: 'NO_OTP', message: 'No OTP found for this email. Please request a new code.' };
  if (Date.now() > entry.expiresAt) {
    delete all[`${email}__${type}`];
    writeLS(LS_OTP, all);
    return { ok: false, reason: 'EXPIRED', message: 'This OTP has expired. Please request a new code.' };
  }
  if (String(entry.code).trim() !== String(code).trim()) {
    return { ok: false, reason: 'MISMATCH', message: 'Incorrect verification code. Please try again.' };
  }
  if (consume) {
    delete all[`${email}__${type}`];
    writeLS(LS_OTP, all);
  }
  return { ok: true };
}

export async function sendOTPEmail({ email, name = '', type = 'VERIFY' }) {
  const e = String(email || '').trim().toLowerCase();
  if (!e) throw new Error('Email is required');
  const left = getResendSecondsLeft({ email: e, type });
  if (left > 0) {
    const wait = Math.ceil(left);
    throw new Error(`Please wait ${wait} second${wait === 1 ? '' : 's'} before requesting a new code.`);
  }
  const apiType = String(type).toUpperCase() === 'FORGOT' ? 'forgot' : 'verify';
  try {
    await customerApi.sendOtp({ email: e, name, type: apiType });
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || 'Could not send verification email.';
    throw new Error(msg);
  }
  storeOTP({ email: e, type, code: 'sent' });
  return { ok: true, sentTo: e, type };
}

export function getLastOTPSentAt({ email, type = 'VERIFY' }) {
  const all = readLS(LS_OTP, {});
  const entry = all[`${email}__${type}`];
  return entry ? entry.createdAt : null;
}

export function canResendOTP({ email, type = 'VERIFY', cooldown = RESEND_COOLDOWN_S }) {
  const t = getLastOTPSentAt({ email, type });
  if (!t) return true;
  return (Date.now() - t) >= cooldown * 1000;
}

export function getResendSecondsLeft({ email, type = 'VERIFY', cooldown = RESEND_COOLDOWN_S }) {
  const t = getLastOTPSentAt({ email, type });
  if (!t) return 0;
  const s = Math.max(0, Math.ceil((cooldown * 1000 - (Date.now() - t)) / 1000));
  return s;
}

export function useInbox() { return getMailbox(); }

export const EMAIL_TEMPLATES = Object.keys(TEMPLATES);
